import React, { useEffect, useState } from "react";
import Typography from "../../../components/Typography";

import Button from "../../../components/button";
import { PLUS_DARK } from "../../../assets";
import { CASE_FOLDER_COLUMNS } from "../../../components/table/columns";

import { selectUser } from "../../../states/slices/authReducer";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import CreateCases from "../components/create-cases";
import Api from "../../../config";
import PaginatedTable from "../../../components/table/Paginated-table";
import { filterOptions, getJSONheader } from "../../../utils";
import Modal from "../../../components/UI/modal";
import {
  caseDetailsModal,
  getSelectedCase,
  joinedAs,
  setCaseDetailsModal,
  setJoinAs,
  setSuitNumber,
} from "../../../states/slices/partyInfo.slice";
import { useNavigate, useSearchParams } from "react-router-dom";
import CaseDetailsModal from "../components/caseDetailsModal";
import { FaFilter } from "react-icons/fa";
import Preloader from "../../../components/preloader";
import { toast } from "react-hot-toast";
import { Transition } from "@headlessui/react";
import { FaEllipsisV } from "react-icons/fa";

function MyFiles() {
  const navigate = useNavigate();
  const caseDetails = useAppSelector(getSelectedCase);
  const [active, setActive] = useState(0);
  const user = useAppSelector(selectUser);
  const [suitmodal, setSuitModal] = useState(false);
  const [suit_no, setSuitNo] = useState("");
  const [open, setOpen] = useState(false);
  const [joincasemodal, setJoinCaseModal] = useState(false);
  const [data, setData] = useState([]);
  const [concludedData, setConcludedData] = useState([]);
  const [nonConcludedData, setNonConcludedData] = useState([]);
  const [searchParams] = useSearchParams();
  const reference = searchParams.get("reference") || "";
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const joinedState = useAppSelector(joinedAs);
  const openCaseModal = useAppSelector(caseDetailsModal);
  const [selected, setSelected] = useState("");
  const [preloaderState, setPreloaderState] = useState<
    "creating" | "almostDone" | "success" | "error" | null
  >(null);
  const [loadingAction, setLoadingAction] = useState<string>("");
  const [fileProcessModal, setFileProcessModal] = useState(false);
  const [fpSuitNo, setFpSuitNo] = useState("");
  const [fpResults, setFpResults] = useState<any[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setSelected(selectedValue);
    // onFilterSelect(selectedValue);
  };

  const fetchData = async (page: number, pageSize: number) => {
    setLoading(true);
    try {
      const query = new URLSearchParams();

      if (page !== undefined) {
        query.append("page", page.toString());
      }
      if (suit_no !== "" || suit_no !== undefined) {
        query.append("search", suit_no);
      }
      if (selected && selected !== "ALL") {
        query.append("status", selected);
      }

      const response = await Api.get(
        `/lawyer/case-folders?${query}`,
        getJSONheader(),
      );
      const { data, meta } = response.data;
      setLoading(false);
      setData(data);
      setTotalPages(meta.last_page);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(1, 10);
  }, [selected, suit_no]);

  const handleVerifyPayment = async () => {
    setPreloaderState("creating");
    const params = {
      reference: reference,
    };
    try {
      const response = await Api.post(
        `/payments/verify`,
        params,
        getJSONheader(),
      );
      setPreloaderState("almostDone");
      setTimeout(() => {
        setPreloaderState("success");
        toast.success(response?.data?.message);
        setTimeout(() => {
          window.location.href = `${window.location.origin}/non-lawyer/my-files`;
        }, 2000);
      }, 2000);
    } catch (error) {
      setPreloaderState("error");
      console.error("Error verifying payment:", error);
    } finally {
      setTimeout(() => setPreloaderState(null), 3000);
    }
  };
  // const fetchCaseHistory = async (page: number, pageSize: number) => {
  //   setLoading(true);
  //   try {
  //     const response = await Api.get(
  //       `/lawyer/cases-history?page=${page}`,
  //       getJSONheader()
  //     );
  //     const { data, meta } = response.data;
  //     setLoading(false);
  //     setConcludedData(data);
  //     setTotalPages(meta.last_page);
  //     console.log(data);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error fetching data:", error);
  //   }
  // };
  // const fetchNonConcludedCases = async (page: number, pageSize: number) => {
  //   setLoading(true);
  //   try {
  //     const response = await Api.get(
  //       `/lawyer/cases-statuses?page=${page}`,
  //       getJSONheader()
  //     );
  //     const { data, meta } = response.data;
  //     setLoading(false);
  //     setNonConcludedData(data);
  //     setTotalPages(meta.last_page);
  //     console.log(data);
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error fetching data:", error);
  //   }
  // };

  useEffect(() => {
    if (reference) {
      handleVerifyPayment();
    }
  }, [reference]);

  return (
    <div className="pt-4 px-2 lg:px-8 pb-36 lg:pb-0">
      <div className="flex items-center justify-between w-full">
        <Typography textStyle="text-[20px] font-medium">My Files</Typography>
        <div className="w-full max-w-sm flex items-center gap-x-2">
          <label className="block mb-2  text-sm font-medium text-gray-700">
            Search:
          </label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              value={suit_no}
              onChange={(e) => {
                setSuitNo(e.target.value);
                if (e.target.value.trim() === "") {
                  fetchData(1, 10);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData(1, 10);
                }
              }}
              placeholder="Search Suit Number or Name"
              className="block w-full outline-none p-2.5 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500"
            />
            <button
              onClick={() => fetchData(1, 10)}
              className="px-4 py-2.5 bg-[#272755] text-white text-sm font-medium rounded-lg hover:bg-opacity-90 transition-all"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div className="w-full pb-20 lg:pb-8">
        <div className="w-full flex flex-row justify-end lg:justify-between mt-7 items-start pl-5 pt-4 lg:pt-0">
          {/* <div className="hidden lg:flex gap-x-5 items-center w-full">
            <div
              onClick={() => setActive(0)}
              className={`flex w-full items-center cursor-pointer py-2 px-3 ${
                active === 0 ? "text-brand_blue font-medium" : ""
              }`}
            >
              <MdOutlineDriveFolderUpload className="h-5 mr-4" />
              <span className="font-400 text-[16px] md:text-[14px] md:leading-[22px]">
                All files {`(${data?.length})`}
              </span>
            </div>
            <div
              onClick={() => setActive(1)}
              className={`flex w-full items-center cursor-pointer py-2 px-3 ${
                active === 1 ? "text-brand_blue font-medium" : ""
              }`}
            >
              <TiTick className="h-5 mr-4" />
              <span className="font-400 text-[16px] md:text-[14px] md:leading-[22px]">
                Pending {`(${concludedData?.length})`}
              </span>
            </div>
            <div
              onClick={() => setActive(2)}
              className={`flex w-full items-center cursor-pointer py-2 px-3 ${
                active === 2 ? "text-brand_blue font-medium" : ""
              }`}
            >
              <MdOutlineSmsFailed className="h-5 mr-4" />

              <span className="font-400 text-[16px] md:text-[14px] md:leading-[22px]">
                Concluded{`(${nonConcludedData?.length})`}
              </span>
            </div>
          </div> */}

          <div className="w-full max-w-xs flex items-center gap-x-2">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Filter:
            </label>

            <select
              value={selected}
              onChange={handleChange}
              className="block w-full outline-none p-2.5 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="" disabled>
                Select a status
              </option>
              {filterOptions.map((option) => (
                <option key={option} value={option}>
                  {option.toLowerCase().replace(/_/g, " ")}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-x-3 w-full justify-end">
            <Button
              icons={""}
              iconClassName="h-[0.9rem]"
              title="Join a case"
              bgColor={"bg-[#13BAED]"}
              onClick={() => setJoinCaseModal(true)}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-[160px]"}
            />
            <Button
              icons={""}
              iconClassName="h-[0.9rem]"
              title="File a Process"
              bgColor={"bg-[#272755]"}
              onClick={() => setFileProcessModal(true)}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-[160px]"}
            />
            <Button
              icons={PLUS_DARK}
              iconClassName="h-[0.9rem] w-3"
              title="Create Case Folder"
              bgColor={""}
              onClick={() => navigate("/non-lawyer/create-case")}
              hoverColor={""}
              textColor={"text-black"}
              className={
                "py-3 w-[180px] border ml-5 border-gray-200 hover:border-2 hover:border-[#13BAED]"
              }
            />
          </div>
        </div>

        <div className="mt-8 lg:flex">
          <div className="w-full lg:mb-0">
            <div className="border-b border-[#F0F0F0] rounded-b-xl">
              <PaginatedTable
                columns={CASE_FOLDER_COLUMNS}
                data={data}
                totalPages={totalPages}
                fetchData={fetchData}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
      <CreateCases {...{ open, setOpen }} />
      <Modal
        maxWidth={"xs"}
        open={joincasemodal}
        close={() => setJoinCaseModal(false)}
      >
        <div className="px-10 flex flex-col gap-y-5">
          <span className="font-semibold text-2xl text-black">
            Select who you are joining as
          </span>

          <div className="flex items-start flex-col gap-y-2">
            <div
              className="flex items-center gap-x-2"
              onClick={() => dispatch(setJoinAs("defendant"))}
            >
              <div className="w-[18px] cursor-pointer h-[18px] border border-[#272755] rounded-full flex items-center justify-center">
                {joinedState === "defendant" && (
                  <div className="w-[10px] h-[10px] rounded-full bg-[#272755]"></div>
                )}
              </div>
              <span className="text-lg font-semibold">Defendant Counsel</span>
            </div>
            <div
              className="flex items-center gap-x-2"
              onClick={() => dispatch(setJoinAs("claimant"))}
            >
              <div className="w-[18px] cursor-pointer h-[18px] border border-[#272755] rounded-full flex items-center justify-center">
                {joinedState === "claimant" && (
                  <div className="w-[10px] h-[10px] rounded-full bg-[#272755]"></div>
                )}
              </div>
              <span className="text-lg font-semibold">Claimant Counsel</span>
            </div>
            <div
              className="flex items-center gap-x-2"
              onClick={() => dispatch(setJoinAs("third_party"))}
            >
              <div className="w-[18px] h-[18px] cursor-pointer border border-[#272755] rounded-full flex items-center justify-center">
                {joinedState === "third_party" && (
                  <div className="w-[10px] h-[10px] rounded-full bg-[#272755]"></div>
                )}
              </div>
              <span className="text-lg font-semibold">Third-Party Counsel</span>
            </div>
          </div>

          <button
            className={`w-full ${
              joinedState === "" && "opacity-50 cursor-not-allowed"
            } py-3 mb-5 rounded font-semibold text-white bg-[#272755] text-[17.8px]`}
            onClick={() => {
              setJoinCaseModal(false);
              setSuitModal(true);
            }}
          >
            Proceed
          </button>
        </div>
      </Modal>
      <Modal maxWidth={"xs"} open={suitmodal} close={() => setSuitModal(false)}>
        <div className="px-10 flex flex-col gap-y-5">
          <span className="font-semibold text-2xl text-black">
            Enter suit number
          </span>

          <input
            type="text"
            value={suit_no}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSuitNo(e.target.value)
            }
            className="w-full px-3 border rounded border-[#CACACA] h-[50px] outline-none"
          />

          <button
            className="w-full py-3 mb-5 rounded font-semibold text-white bg-[#272755] text-[17.8px]"
            onClick={() => {
              navigate(`/non-lawyer/search-result?suit_number=${suit_no}`);
              dispatch(setSuitNumber(suit_no));
            }}
          >
            Search for case
          </button>
        </div>
      </Modal>
      <Modal
        maxWidth={"md"}
        open={fileProcessModal}
        close={() => setFileProcessModal(false)}
      >
        <div className="px-6 py-6">
          <span className="text-2xl font-semibold text-black">
            File a Process
          </span>
          <div className="mt-4">
            <span className="text-sm font-medium">Enter suit number</span>
            <input
              type="text"
              value={fpSuitNo}
              onChange={(e) => setFpSuitNo(e.target.value)}
              className="w-full px-3 border rounded border-[#CACACA] h-[50px] outline-none mt-2"
            />
            <div className="flex justify-end items-center mt-3">
              <Button
                iconClassName="h-[0.9rem] w-3"
                title="Search"
                isLoading={isSearching}
                bgColor={"bg-[#272755]"}
                onClick={async () => {
                  setIsSearching(true);
                  try {
                    const response = await Api.get(
                      `/lawyer/case-folders/suit-number?suit_number=${fpSuitNo}`,
                      getJSONheader(),
                    );
                    const { data } = response.data;
                    setFpResults(data ? [data] : []);
                  } catch (e) {
                    toast.error("Unable to fetch case folder");
                    setFpResults([]);
                  } finally {
                    setIsSearching(false);
                  }
                }}
                hoverColor={""}
                textColor={"text-white"}
                className={"py-3 w-32"}
              />
            </div>
            {isSearching && (
              <div className="mt-2 text-sm text-gray-500">Searching…</div>
            )}
          </div>
          {!isSearching && fpResults.length > 0 && (
            <div className="mt-6">
              <PaginatedTable
                columns={[
                  {
                    Header: "S/No.",
                    Cell: ({ cell: { row } }: any) => (
                      <span className="text-xs">{Number(row.id) + 1}</span>
                    ),
                  },
                  { Header: "Suit no", accessor: "suit_number" },
                  { Header: "Case Title", accessor: "title" },
                  {
                    Header: "Action",
                    Cell: ({ cell: { row } }: any) => {
                      const navigate = useNavigate();
                      const [dropdown, setDropdown] = useState(false);
                      return (
                        <>
                          <FaEllipsisV
                            size={20}
                            color="#101828"
                            className="hover:bg-green-100 p-1 cursor-pointer rounded-md"
                            onClick={() => setDropdown((prev) => !prev)}
                          />
                          <Transition
                            as="div"
                            show={dropdown}
                            className="w-[170px] h-[70px] flex flex-col gap-y-2 items-start rounded-xl shadow-lg absolute right-20 z-[9999] bg-white mt-6 text-sm font-medium py-5"
                          >
                            <span
                              className="hover:bg-[#BFD0F2] w-full py-1 pl-3 cursor-pointer"
                              onClick={() => {
                                navigate(
                                  `/non-lawyer/file-a-process?id=${row?.original?.id}`,
                                );
                                setFileProcessModal(false);
                              }}
                            >
                              File a process
                            </span>
                          </Transition>
                        </>
                      );
                    },
                  },
                ]}
                data={fpResults}
                totalPages={1}
                fetchData={() => {}}
                isLoading={false}
              />
            </div>
          )}
        </div>
      </Modal>
      <CaseDetailsModal
        data={caseDetails}
        hide={() => dispatch(setCaseDetailsModal(false))}
        show={openCaseModal}
      />
      <Preloader
        preloaderState={preloaderState}
        action={loadingAction || "Loading case folders"}
      />
    </div>
  );
}

export default MyFiles;
